import type { Theme } from '@mui/material/styles'

/**
 * Establecemos los colores de background de los inputs
 * @param theme
 * @param disabled
 * @param readOnly
 * @author isi-template
 */
export const getInputBackground = (
  theme: Pick<Theme, 'palette'>,
  disabled = false,
  readOnly = false,
): string => {
  const { background } = theme.palette

  if (disabled) return background.inputDisabled
  if (readOnly) return background.inputReadOnly
  return background.input
}
